export enum PlanType {
  wells = 'wells',
  rigs = 'rigs',
}
